/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * PlaceholderIcon
 */
export default class PlaceholderIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><g fillRule="nonzero"><path d="M5.797 3.018a.994.994 0 01.484 1.925l-.113.028C5.49 5.1 5.13 5.46 4.965 6.2a.994.994 0 11-1.94-.434c.335-1.502 1.301-2.469 2.772-2.748zM20.96 5.797a.994.994 0 01-1.926.484l-.028-.113c-.13-.679-.489-1.038-1.229-1.203a.994.994 0 01.434-1.94c1.502.335 2.468 1.301 2.748 2.772zM18.18 20.989a.994.994 0 01-.484-1.925l.113-.029c.678-.129 1.038-.488 1.203-1.228a.994.994 0 111.94.434c-.335 1.502-1.301 2.468-2.772 2.748zM3.018 18.18a.994.994 0 011.925-.484l.028.113c.13.678.489 1.038 1.229 1.203a.994.994 0 01-.434 1.94c-1.502-.335-2.469-1.301-2.748-2.772zM14.871 3c.624 0 1.129.445 1.129.994 0 .51-.436.93-.997.988l-.132.006H13.63c-.624 0-1.129-.445-1.129-.994 0-.51.436-.93.997-.987L13.63 3h1.242zM14.871 18.977c.624 0 1.129.445 1.129.994 0 .51-.436.93-.997.988l-.132.006H13.63c-.624 0-1.129-.445-1.129-.994 0-.51.436-.93.997-.987l.132-.007h1.242zM5 14.871C5 15.495 4.555 16 4.006 16c-.51 0-.93-.436-.988-.997l-.006-.132V13.63c0-.624.445-1.129.994-1.129.51 0 .93.436.987.997L5 13.63v1.242zM21 14.871c0 .624-.445 1.129-.994 1.129-.51 0-.93-.436-.988-.997l-.006-.132V13.63c0-.624.445-1.129.994-1.129.51 0 .93.436.987.997l.007.132v1.242zM10.371 3c.624 0 1.129.448 1.129 1 0 .513-.436.936-.997.993L10.37 5H9.13C8.505 5 8 4.552 8 4c0-.513.436-.936.997-.993L9.13 3h1.242zM10.371 18.977c.624 0 1.129.448 1.129 1 0 .513-.436.935-.997.993l-.132.007H9.13c-.624 0-1.129-.448-1.129-1 0-.513.436-.936.997-.993l.132-.007h1.242zM5 10.371c0 .624-.448 1.129-1 1.129-.513 0-.936-.436-.993-.997L3 10.37V9.13C3 8.505 3.448 8 4 8c.513 0 .936.436.993.997L5 9.13v1.242zM21 10.371c0 .624-.448 1.129-1 1.129-.513 0-.936-.436-.993-.997L19 10.37V9.13C19 8.505 19.448 8 20 8c.513 0 .936.436.993.997L21 9.13v1.242z"/></g></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

